import React from 'react';
import { Button, Modal, FormControl, FormGroup, Col } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import _ from 'underscore';
import { titleize } from 'underscore.string';
import UserActionCreators from '../../../actions/UserActionCreators';

function getEmptyState() {
  return {
    username: '',
    email: '',
    first_name: '',
    last_name: '',
    password: '',
  };
}

class RegisterUserForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState() {
    return getEmptyState();
  }

  onChange(key) {
    return (e) => {
      this.setState({ [key]: e.target.value });
    };
  }

  close() {
    this.setState(getEmptyState());
    this.props.onHide();
  }

  register() {
    return (e) => {
      e.preventDefault();
      UserActionCreators.addAdminUser(this.state);
      this.close();
    };
  }

  render() {
    const { t } = this.props;
    var disabled =
      _.isEmpty(this.state.username) ||
      _.isEmpty(this.state.email) ||
      _.isEmpty(this.state.first_name) ||
      _.isEmpty(this.state.last_name) ||
      _.isEmpty(this.state.password);
    return (
      <Modal show={this.props.show} onHide={this.props.onHide}>
        <Modal.Header closeButton>
          <Modal.Title>{t('REGISTER_AN_ADMIN_USER')}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form className="form-horizontal">
            <FormGroup>
              <Col xs={12}>
                <p>{t('USERNAME')}</p>
              </Col>
              <Col xs={12}>
                <FormControl
                  type="text"
                  ref="username"
                  onChange={this.onChange('username')}
                  value={this.state.username}
                />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col xs={12}>
                <p>{t('EMAIL')}</p>
              </Col>
              <Col xs={12}>
                <FormControl
                  type="text"
                  ref="email"
                  placeholder="example@cargomatic.com"
                  onChange={this.onChange('email')}
                  value={this.state.email}
                />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col xs={12}>
                <p>{t('FIRST_NAME')}</p>
              </Col>
              <Col xs={12}>
                <FormControl
                  type="text"
                  ref="first_name"
                  placeholder="John"
                  onChange={this.onChange('first_name')}
                  value={this.state.first_name}
                />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col xs={12}>
                <p>{t('LAST_NAME')}</p>
              </Col>
              <Col xs={12}>
                <FormControl
                  type="text"
                  ref="last_name"
                  placeholder="Smith"
                  onChange={this.onChange('last_name')}
                  value={this.state.last_name}
                />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col xs={12}>
                <p>{t('PASSWORD')}</p>
              </Col>
              <Col xs={12}>
                <FormControl
                  ref="password"
                  type="password"
                  onChange={this.onChange('password')}
                  value={this.state.password}
                />
              </Col>
            </FormGroup>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => this.close()}>{titleize(t('CLOSE'))}</Button>
          <Button
            bsStyle="primary"
            onClick={this.register()}
            disabled={disabled}
          >
            {t('REGISTER')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default withTranslation()(RegisterUserForm);
